var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageNoticias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 93.5C7.99167 93.5 5.55989 92.4891 3.538 90.4672C1.51611 88.4453 0.503444 86.0118 0.5 83.1667V10.8333C0.5 7.99167 1.51267 5.55989 3.538 3.538C5.56333 1.51611 7.99511 0.503444 10.8333 0.5H83.1667C86.0083 0.5 88.4418 1.51267 90.4672 3.538C92.4925 5.56333 93.5034 7.99511 93.5 10.8333V83.1667C93.5 86.0083 92.4891 88.4418 90.4672 90.4672C88.4453 92.4925 86.0118 93.5034 83.1667 93.5H10.8333ZM10.8333 83.1667H83.1667V10.8333H10.8333V83.1667ZM16 72.8333H78L58.625 47L43.125 67.6667L31.5 52.1667L16 72.8333Z",
    fill: "#6B7280",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNoticias);
export default __webpack_public_path__ + "static/media/imageNoticias.6173ab746e9af8548278e75b5031ba1d.svg";
export { ForwardRef as ReactComponent };